import React, { Component } from 'react'
import RestApiUtils from '../../../../apiclient/moebli/RestApiUtils'
import AddDsraUpdateCsModalUI from './AddDsraUpdateCsModalUI.js'

class AddDsraUpdateCsModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      title: '',
      dueDate: null,
      submitted: false,
      successMsg: null,
      errorList: []
    }
  }

  componentDidUpdate(prevProps) {
    // Reset form whenever modal is opened
    if (this.props.addMode && !prevProps.addMode) {
      this.setState({
        title: '',
        dueDate: null,
        submitted: false,
        successMsg: null,
        errorList: []
      })
    }
  }

  render() {
    return (
      <AddDsraUpdateCsModalUI
        context={this.props.context}
        addMode={this.props.addMode}
        onCancelClick={this.props.onCancelClick}
        //
        title={this.state.title}
        onTitleChange={this.onTitleChange}
        dueDate={this.state.dueDate}
        onDueDateChange={this.onDueDateChange}
        //
        submitted={this.state.submitted}
        successMsg={this.state.successMsg}
        errorList={this.state.errorList}
        onSubmitClick={this.onSubmitClick}
      />
    )
  }

  onTitleChange = (name, value) => {
    let val
    if (value !== undefined) {
      val = value
    } else if (name && name.target !== undefined) {
      val = name.target.value
    } else {
      val = name
    }
    this.setState({ title: val || '', errorList: [] })
  }

  onDueDateChange = (name, value) => {
    const val = value !== undefined ? value : name
    this.setState({ dueDate: val, errorList: [] })
  }

  onSubmitClick = () => {
    const { title, dueDate } = this.state

    if (!title || typeof title !== 'string' || !title.trim()) {
      this.setState({ errorList: ['Condition title is required'] })
      return
    }

    this.setState({ submitted: true, successMsg: null, errorList: [] })

    const body = {
      title: title.trim(),
      dueDate: dueDate || null,
      isPromoterLevel: false,
      isMovable: true
    }

    // POST /api/su/loans/{loanId}/compliances/cs/dsra-release
    RestApiUtils.post(
      this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/compliances/cs/dsra-release`,
      this.onSubmitClickCallback,
      body
    )
  }

  onSubmitClickCallback = (response) => {
    let errorList = []
    if (response.errorList && response.errorList.length) {
      response.errorList.forEach(error => errorList.push(error.message))
    }

    this.setState({
      submitted: false,
      successMsg: response.success ? 'DSRA release condition added successfully' : null,
      errorList
    })

    if (errorList.length === 0) {
      setTimeout(() => {
        this.props.onRefreshClick('noBusy')
        this.props.onCancelClick()
      }, 800)
    }
  }
}

export default AddDsraUpdateCsModalSF